import { ADD_ERROR, ErrorsActionTypes, REMOVE_ERROR } from './types'

export const addError = (error: any): ErrorsActionTypes => ({ type: ADD_ERROR, payload: error })

export const removeError = (error: any): ErrorsActionTypes => ({ type: REMOVE_ERROR, payload: error })
